import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, modulo } = obj
  const response = await http[verb]('/modulo', modulo)

  if (response !== null) {
    modulo.id = response.data.data.id
    update(context, { ...modulo })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/modulo/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/modulo')
  if (response !== null) {
    const modulos = response.data
    commit('SET_LIST', modulos)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { modulo: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/modulo/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/modulos/store/actions.js